/* eslint-disable react/no-unknown-property */
import React, { Component, RefObject } from 'react'
import isArray from 'lodash/isArray'
import classNames from 'classnames/bind'

// Libs
import { getParameterByName } from '@/utils/url'
import { isEmpty } from 'lodash-es'
import { handleGtmClickLiveRoomSetup } from '@/methods/handleGtmEvent'
import { isLoop } from '@/utils/url-tool'

// Components
import Icon from '@/assets/icons'

// constants
import { GtmClickLiveRoomSetupPlayStatus } from '@/constants/gtmEvent'

// import './index.scss'
import styles from './style.module.scss'

const cx = classNames.bind(styles)

type Props = {
  playStatus: number
  totalTime: number
  onCheckoutPlayStatus: (status: number) => void
  currentTime: number
  flipStamp: any[]
  starStamp: any[]
  onChangeCurrent: (time: number) => void
  getSnapshotByTime: () => void
  className: string
  jump: (time: number) => void
}

type State = {
  progressWrapperWidth: number
  progressWidth: number
  previewLeft: number
  canDrag: boolean
  previewTime: string
  formatCurrentTime: string
  previewUrl: string
  proWrapperInfo: DOMRect | null
}

class PlayBackProgress extends Component<Props, State> {
  progressPercent: RefObject<HTMLDivElement>

  constructor(props: Props) {
    super(props)
    this.progressPercent = React.createRef<HTMLDivElement>()
  }

  static defaultProps: Partial<Props> = {
    playStatus: -1,
    totalTime: 0,
    onCheckoutPlayStatus: () => {}, //切换播放状态 1播放 -1 暂停 0 停止
    currentTime: 0,
    flipStamp: [],
    starStamp: [],
    onChangeCurrent: () => {},
    getSnapshotByTime: () => {},
  }

  state: State = {
    progressWrapperWidth: 0,
    progressWidth: 0,
    previewLeft: 0,
    canDrag: false,
    previewTime: '00:00:00',
    formatCurrentTime: '00:00:00',
    previewUrl: '',
    proWrapperInfo: null,
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.currentTime !== this.props.currentTime) {
      this.setState({
        formatCurrentTime: this.formatTime(this.props.currentTime),
      })
      this.setProgressPosition(this.props.currentTime)
    }

    if (prevState.progressWrapperWidth !== this.state.progressWrapperWidth && this.props.totalTime) {
      this.setProgressPosition(this.props.currentTime)
    }

    if (prevProps.currentTime !== this.props.currentTime && this.props.currentTime === 0) {
      isLoop() && this.props.onCheckoutPlayStatus(1)
    }
  }

  componentDidMount() {
    window.addEventListener('mousemove', this.handleDragMove)
    window.addEventListener('mouseup', this.handleDragEnd)
    window.addEventListener('touchmove', this.handleDragMove)
    window.addEventListener('touchend', this.handleDragEnd)
    this.initPosition()
    this.autoPlay(this.props.playStatus) //自動撥放
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleDragMove)
    window.removeEventListener('mouseup', this.handleDragEnd)
    window.removeEventListener('touchmove', this.handleDragMove)
    window.removeEventListener('touchend', this.handleDragEnd)
  }

  initPosition() {
    if (!this.progressPercent.current) return
    const proWrapperInfo = this.progressPercent.current.getBoundingClientRect()
    this.setState({
      progressWrapperWidth: proWrapperInfo.width,
      formatCurrentTime: this.formatTime(this.props.currentTime),
      proWrapperInfo,
    })
  }

  resize() {
    this.initPosition()
  }

  setProgressPosition(time: any) {
    if (this.props.totalTime <= 0) return
    const progressWidth = this.state.progressWrapperWidth * (time / this.props.totalTime)
    this.setState({
      progressWidth,
    })
  }

  setTagPosition(data = []) {
    if (!isArray(data)) return []
    return data.map((item) => ({
      position: this.state.progressWrapperWidth * (item / this.props.totalTime),
      time: item,
      active: this.props.currentTime >= item,
    }))
  }

  formatTime(time: any) {
    if (time < 0) {
      return '00:00'
    }
    time = time / 1000
    let hours: number | string = Math.floor(time / 3600)
    hours = hours >= 10 ? hours : `0${hours}`
    let minutes: number | string = Math.floor((time % 3600) / 60)
    minutes = minutes >= 10 ? minutes : `0${minutes}`
    let seconds: number | string = Math.floor((time % 3600) % 60)
    seconds = seconds >= 10 ? seconds : `0${seconds}`
    return `${hours}:${minutes}:${seconds}`
  }

  handleSeekPosition = (event: any) => {
    const proWrapperInfo = this.state.proWrapperInfo
    if (!proWrapperInfo) return

    let clientX = event.clientX
    if (!clientX) {
      // for ios touch event
      const touch = event.changedTouches[0]
      clientX = touch.clientX
    }

    let progressWidth = clientX - proWrapperInfo.left - 10
    //if (progressWidth < 0) return
    if (progressWidth < 0) progressWidth = 0
    const percent = progressWidth / this.state.progressWrapperWidth
    if (percent >= 1) {
      this.props.onChangeCurrent(this.props.totalTime)
      return
    }
    const currentTime = this.props.totalTime * percent
    this.props.onChangeCurrent(currentTime)
  }

  handleDragBegin = () => {
    if (this.state.canDrag) return
    this.setState({
      canDrag: true,
    })
  }

  handleDragMove = (event: any) => {
    if (!this.state.canDrag) return
    const proWrapperInfo = this.state.proWrapperInfo
    if (!proWrapperInfo) return

    let clientX = event.clientX
    if (!clientX) {
      // for ios touch event
      const touch = event.changedTouches[0]
      clientX = touch.clientX
    }

    if (clientX > proWrapperInfo.right || clientX < proWrapperInfo.left) return
    const progressWidth = clientX - proWrapperInfo.left
    this.setState({
      progressWidth,
    })
  }

  handleDragEnd = (event: any) => {
    if (!this.state.canDrag) return
    this.setState({
      canDrag: false,
    })
    this.handleSeekPosition(event)
  }

  autoPlay = (playStatus: number) => {
    if (playStatus === 1) return
    setTimeout(() => {
      this.props.onCheckoutPlayStatus(1)
      this.syncTime()
    }, 500)
  }

  syncTime = () => {
    try {
      const t = getParameterByName('t')
      if (isEmpty(t)) return

      const currentTime = this.parseSyncTimeToMilliSec(t ?? '')
      if (currentTime === 0) return

      console.log('sync time to:', currentTime / 1000)
      this.props.onChangeCurrent(currentTime)
    } catch (ex: any) {
      console.error('sync time ex:', ex)
    }
  }

  parseSyncTimeToMilliSec = (syncTime: string) => {
    const regex = /^(\d+m)?(\d+s)?$/
    const match = syncTime.match(regex)

    if (match) {
      const minutes = match[1] ? parseInt(match[1], 10) : 0
      const seconds = match[2] ? parseInt(match[2], 10) : 0
      const totalSeconds = minutes * 60 + seconds
      return totalSeconds * 1000
    } else {
      console.error('無法解析時間格式:', syncTime)
      return 0
    }
  }

  render() {
    const proStyle = {
      width: this.state.progressWidth,
    }
    const guideStyle = {
      left: this.state.progressWidth - 4,
    }
    // const previewStyle = {
    //   left: this.state.previewLeft,
    // }

    const { playStatus, jump } = this.props

    return (
      <div className={cx('progress-wrapper', 'flex-row-between', `${this.props.className}`)}>
        <div className={cx('flex-row-left', 'left')}>
          <div
            className={cx('operation')}
            onClick={() => {
              const isPlaying = playStatus === 1
              const isPaused = playStatus === -1

              if (isPlaying || isPaused) {
                handleGtmClickLiveRoomSetup({
                  playStatus: isPlaying ? GtmClickLiveRoomSetupPlayStatus.PAUSE : GtmClickLiveRoomSetupPlayStatus.PLAY,
                })
              }

              this.props.onCheckoutPlayStatus(isPlaying ? -1 : 1)
            }}
          >
            {playStatus === 1 ? <Icon.Pause /> : <Icon.Play />}
          </div>
          <div
            className={cx('operation')}
            onClick={() => {
              handleGtmClickLiveRoomSetup({ playStatus: GtmClickLiveRoomSetupPlayStatus.BACKWARD })
              jump(-15000)
            }}
          >
            <Icon.FastBack />
          </div>
          <div
            className={cx('operation')}
            onClick={() => {
              handleGtmClickLiveRoomSetup({ playStatus: GtmClickLiveRoomSetupPlayStatus.FORWARD })
              jump(15000)
            }}
          >
            <Icon.FastForward />
          </div>
        </div>
        <div className={cx('progress-bar-wrapper')}>
          <div className={cx('progress-info-wrapper')}>
            <div className={cx('progress-percent', 'flex-1')} id='progress-percent' onClick={this.handleSeekPosition} ref={this.progressPercent}>
              <div className={cx('percent')} style={proStyle} />
              <div
                className={cx('percent-guide')}
                style={guideStyle}
                onMouseDown={this.handleDragBegin}
                onMouseUp={this.handleDragEnd}
                onTouchStart={this.handleDragBegin}
                //onTouchMove={this.handleDragMove}
                onTouchEnd={this.handleDragEnd}
              >
                <div className={cx('inside-guide')} />
              </div>
            </div>
          </div>
          <div className={cx('progress-time')}>
            <span className={cx('current-play-time')}>{this.state.formatCurrentTime}</span>
            <span className={cx('current-play-time')}>{this.formatTime(this.props.totalTime)}</span>
          </div>
        </div>
      </div>
    )
  }
}
export default PlayBackProgress
